/** *
 * Return true if num is even.
 * @param num
 */
export function isEven(num: number) {
  return num % 2 === 0;
}

/** *
 * Interface for use one counter functionality at any component, primary created for table keys
 * at React.js (Every row in React needs unique id, but its not a good practice use the index of the row),
 * so, i created this counter interface to create keys when the object doesn't have .id atribute.
 */
export interface Counter {
  next(): number;
  get(): number;
}

/** *
 * Create the Counter with some initial value and the next functionality, that will add 1 at the counter and return this number
 * @param init
 */
export function new_counter(init = 0): Counter {
  return {
    next: () => {
      init += 1;
      return init;
    },
    get: () => {
      return init;
    },
  };
}
